import React from "react";
import ChartContent from "./ChartContent";
const ContentDashboard = (props) => {
  return (
    <div>
      <ChartContent data={props.data} />
    </div>
  );
};

export default ContentDashboard;
